const BASE62_CHARS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const FILTER_ID_LENGTH = 12;

export function generateFilterId(): string {
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const bytes = new Uint8Array(FILTER_ID_LENGTH);
    crypto.getRandomValues(bytes);
    let result = '';
    for (let i = 0; i < FILTER_ID_LENGTH; i++) {
      result += BASE62_CHARS[bytes[i] % 62];
    }
    return result;
  }

  let result = '';
  for (let i = 0; i < FILTER_ID_LENGTH; i++) {
    result += BASE62_CHARS[Math.floor(Math.random() * 62)];
  }
  return result;
}
